import { ready } from '../utils/readyinit';
import initBlogSearch from '../sections/blog/blog-search';

ready(() => {
  initBlogSearch();
});
